import React, { useEffect, useState } from "react";
import { A_P_TAB_TEXT } from "../../utilities/constants";
import MainTabs from "../tabs";
import LoadingSpinner from "../loading";
import DataNotFound from "../dataNotFound";
import Notification from "../notification";
import { replaceVirtualController } from "../../utilities/helpers";
import APList from "./APList";
import Footer from "./Footer";
import SelectedItem from "./SelectedItem";

import "./index.scss";
import { ACCESS_POINT_TYPES } from "./constants";

const APWizardPage = ({
  fieldsData,
  wizardStep,
  changeWizardPage,
  data,
  handleCloseModal,
  showNotificationPopUp,
  templateData,
  handleNotification,
  componentSourceOptions,
  handleSaveAccessPoint,
  acuId,
  prevAccessPoints,
  ACUModel,
}) => {
  const [step, setStep] = useState(2);
  const [aPItemList, setAPItemList] = useState(true);
  const [loading, setLoading] = useState(null);
  const [selectedAPItem, setSelectedAPItem] = useState(null);
  const [error, setError] = useState(null);
  const [serialNumberError, setSerialNumberError] = useState(null);
  const [serialNumberLoading, setSerialNumberLoading] = useState(false);
  const [showSearchResult, setShowSearchResult] = useState(false);
  const [deviceName, setDeviceName] = useState("");
  const [haveSerialNumber, setHaveSerialNumber] = useState(true);
  const [selectedTemplate, setSelectedTemplate] = useState("null");
  const [selectedPorts, setSelectedPorts] = useState({});
  const [savedData, setSavedData] = useState({});
  const [customTemplate, setCustomTemplate] = useState({});
  const [deletedData, setDeletedData] = useState({});

  useEffect(() => {
    setStep(+wizardStep || 1);
    setAPItemList([...data] || []);
    setSelectedAPItem(data[0] || null);
    [data[0]?.type];
    if (templateData && data[0] && data[0].type && templateData[data[0].type]) {
      handelSetSelectedPorts(
        templateData[data[0].type].checkBox[0],
        prevAccessPoints
      );
      setSelectedTemplate(templateData[data[0].type].checkBox[0]);
      addIdentificationForData(templateData[data[0].type].checkBox[0]);
    }
    setLoading(false);
  }, [data]);

  const handleStepChange = (change) => {
    setStep((prev) => Math.min(3, Math.max(1, prev + change)));
    if (step + change < 2) {
      changeWizardPage("1");
    }
  };

  const addIdentificationForData = (data) => {
    if (!data.data?.readers) {
      return data;
    }
    const newData = { ...data };
    newData.data.readers = newData.data.readers.map((item) => {
      return {
        ...item,
        defaultName: `${item.port}`,
      };
    });

    return newData;
  };

  const handelSetSelectedPorts = (data, state) => {
    const result = JSON.parse(JSON.stringify(state)) || {
      input: {},
      output: {},
      readers: {},
    };
    if (!data.data) {
      setSelectedPorts(result);
      return 0;
    }
    // for (let item of data.data.readers) {
    //   if (result.readers[item.component_source]) {
    //     result.readers[item.component_source] = {
    //       ...result.readers[item.component_source],
    //       [item.port]: true,
    //     };
    //   } else {
    //     result.readers[item.component_source] = {
    //       [item.port]: true,
    //     };
    //   }
    // }
    // const resources =
    //   typeof data.data.resources == "string"
    //     ? JSON.parse(data.data.resources)
    //     : data.data.resources;

    // for (const key in resources) {
    //   if (resources[key].input) {
    //     if (result.input[resources[key].component_source]) {
    //     } else {
    //       result.input[resources[key].component_source] = {
    //         [resources[key].input]: true,
    //       };
    //     }
    //   } else {
    //     if (result.output[resources[key].component_source]) {

    //     } else {
    //       result.output[resources[key].component_source] = {
    //         [resources[key].output]: true,
    //       };
    //     }
    //   }
    // }
    setSelectedPorts(result);
  };

  const handleSearchWithSerialNumber = async (serialNumber) => {};

  const handleValidationBeforeSave = (resources) => {
    for (const key in resources) {
      if (resources[key].output && resources[key].relay_mode == 1) {
        if ("impulse_time" in resources[key]) continue;
        handleNotification({ message:'impulse time required', type:"danger" })
        return false
      }
    }
    return true
  };

  const handleFinishStep = async () => {
    let readers = [];
    const resources = {};
    for (let item in savedData) {
      if (savedData[item].item_type && savedData[item].item_type == "readers") {
        resources[item] = {
          ...savedData[item],
          component_source: savedData[item].component_source.id || 0,
        };
      } else {
        readers.push({
          ...savedData[item],
          component_source: savedData[item].component_source.id || 0,
        });
      }
    }
    if (!handleValidationBeforeSave(resources)) { 
      return
    }

    const obj = {
      readers,
      resources,
      ...customTemplate,
      type: selectedTemplate.data.type,
      acu: acuId,
    };
    handleSaveAccessPoint(obj);
  };

  const deleteRecourse = (data) => {
    const result = { ...selectedPorts };
    const keyPort = data.input ? "input" : data.output ? "output" : "readers";
    if (keyPort !== "readers") {
      delete result[keyPort][data.component_source][data[keyPort]];
    } else {
      delete result[keyPort][data[keyPort]];
    }

    setSelectedPorts(result);
    const newData = { ...savedData };
    const key = data.name ? data.name : `RFID${data.defaultName}`;

    delete newData[key];

    setDeletedData((prev) => {
      return {
        ...prev,
        [key]: true,
      };
    });

    setSavedData({ ...newData });
  };

  const handleAddAnyway = async () => {};

  const isDisabledFinishButton = !!serialNumberError;

  const isDisabledNextButton = () => {
    if (serialNumberLoading) return true;
    if (!haveSerialNumber) return false;
    if (step > 1) return !showSearchResult;
    return !!serialNumberError;
  };

  const isDisabledBackButton = () => {
    if (serialNumberLoading) return true;
    return step === 3;
  };

  const shouldShowNextButton = () =>
    !haveSerialNumber || (!error && !serialNumberError && step < 3);

  const disableNextButton = () => {
    if (typeof selectedTemplate == "string") {
      return true;
    }
    if (!!selectedTemplate.data) {
      return false;
    }
  };

  if (loading) return <LoadingSpinner />;
  return (
    <section>
      <MainTabs tabsTexts={A_P_TAB_TEXT} activeTabIndex={step} />
      {templateData && !Object.keys(templateData).length ? (
        <section>
          <h2>No Template For This ACU </h2>
        </section>
      ) : null}
      {step === 1 ? (
        <></>
      ) : (
        <>
          {error ? (
            <>
              <DataNotFound />
            </>
          ) : (
            <>
              {step == "2" ? (
                <>
                  {aPItemList.length > 0 ? (
                    <APList
                      id={selectedAPItem.id}
                      itemList={aPItemList || []}
                      onClick={(e) => {
                        setSelectedAPItem(e);
                        setSelectedPorts({});
                      }}
                      selectedTemplate={selectedTemplate}
                      templateData={templateData}
                      setSelectedTemplate={(template) => {
                        if (template) {
                          setSelectedTemplate(
                            addIdentificationForData(template)
                          );
                          handelSetSelectedPorts(template, prevAccessPoints);
                          return;
                        }
                        setSelectedTemplate(template);
                      }}
                    />
                  ) : null}
                </>
              ) : (
                <div>
                  <SelectedItem
                    deletedData={deletedData}
                    deleteRecourse={deleteRecourse}
                    savedData={savedData}
                    setSavedData={setSavedData}
                    setSelectedPorts={setSelectedPorts}
                    selectedPorts={selectedPorts}
                    componentSourceOptions={componentSourceOptions}
                    item={selectedAPItem}
                    selectedTemplate={selectedTemplate}
                    fieldsData={fieldsData}
                    customTemplate={customTemplate}
                    setCustomTemplate={setCustomTemplate}
                    ACUModel={ACUModel}
                  />
                </div>
              )}
            </>
          )}
          <Footer
            isLastStep={step === 3}
            disabledCancel={false}
            disabledBack={false}
            disabledNext={disableNextButton()}
            disabledFinish={false}
            handelCancel={(e) => {
              handleCloseModal();
            }}
            handleBack={() => {
              handleStepChange(-1);
            }}
            handleNext={() => {
              handleStepChange(1);
            }}
            handleFinish={() => {
              handleFinishStep();
            }}
          />
        </>
      )}
    </section>
  );
};

export default APWizardPage;
